'use client'


import LaserProfilePage from '@/components/LaserProfile/LaserProfilePage'


export default function Home() {

    return <LaserProfilePage />
}
